import React from "react";
import { Box, Typography } from "@mui/material";
import DataTable from "react-data-table-component";
import Pagination from "react-js-pagination";
import { BarLoader  } from "react-spinners";
import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";

import BaseImage from "../BaseImage";

import { customStyles } from "./styles";
import { PatientDetailStyles } from "./PatientDetailStyles"
import IconNotificationYellow from "../../assets/images/icons/icon-notification-yellow.svg"

const CustomLoader = () => (
	<Box 
    sx={{ 
      height: '300px',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
		<BarLoader color="#36d7b7" />
		<Typography variant="body" mt='8px'>Loading...</Typography>
	</Box>
);

const CustomizeCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => {
  return(
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <input 
        type="checkbox"
        className="data-table-check-input"
        ref={ref}
        onClick={onClick}
        {...rest}
      />
      <label className="form-check-label" id="booty-check" />
    </Box>
  )
})

export const NoDataComponent = ({ noText }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: '24px'
      }}
    >
      <BaseImage 
        src={IconNotificationYellow}
        sx={{
          width: '23px',
          height: '23px',
          mr: '8px',
          mt: '-4px'
        }}
      />
      <Typography variant="body" color="primary.darkGray">
        {noText}
      </Typography>
    </Box>
  )
}

export default function ReactDataTable({
  page,
  columnDefs,
  rowData,
  activePage,
  itemsCountPerPage = 10,
  defaultRowsPerPage,
  totalItemsCount,
  dataOffset,
  pageRangeDisplayed,
  onSort,
  onRowClicked,
  onPagination,
  onChangePageSize,
  onRowsPerPageChange,
  isPagination,
  isCustomizePagination,
  isPaginationButton = false,
  loadingData = false,
  paginationPosition = 'bottom',
  noText,
  ...props
}) {
  // const recordsFrom = parseInt((activePage - 1) * itemsCountPerPage) + 1;
  // const recordsTo = recordsFrom + itemsCountPerPage - 1;

  const style = paginationPosition === 'top' && {
    display: 'flex',
    flexDirection: 'column-reverse',

    '.patient-table-root': {
      maxHeight: '100%'
    },

    '.rdt_Pagination': {
      position: 'relative',
      borderTop: '0 solid',
      bgcolor: 'white'
    },
    '.rdt_Pagination span.iOgnCO': {
      position: 'absolute',
      right: '33px',
      color: '#5B87EF',
      fontWeight: 500,
      fontSize: '12px',
      fontFamily: 'Poppins'
    },
    '#pagination-first-page': {
      display: 'none'
    },
    '#pagination-last-page': {
      display: 'none'
    },
    '#pagination-previous-page': {
      mr: '88px'
    }
  }

  return (
    <Box
      sx={{
        ...style
      }}
    >
      <DataTable
        className='patient-table-root'
        columns={columnDefs}
        customStyles={page === 'patient-detail' ? PatientDetailStyles : customStyles}
        data={rowData}
        highlightOnHover
        pointerOnHover
        fixedHeader
        striped
        onSort={onSort}
        onRowClicked={onRowClicked}
        overflowY
        selectableRowsComponent={CustomizeCheckbox}
        selectableRowDisabled={(row) => row?.needsReview}
        // overflowYOffset="300px"
        responsive
        pagination={isPagination}
        paginationComponentOptions={{
          noRowsPerPage: false,
        }}
        paginationPerPage={defaultRowsPerPage}
        noDataComponent={<NoDataComponent noText={noText} />}
        progressPending={loadingData}
        progressComponent={<CustomLoader />}
        persistTableHead={true}
        {...props}
      />
      <TablePageOptionsWrapper>
        {isCustomizePagination && totalItemsCount !== 0 && (
          <>
            {/* <PagesizeOptions
              value={itemsCountPerPage}
              onChange={onChangePageSize}
            >
              <PagesizeOption value="10">10</PagesizeOption>
              <PagesizeOption value="25">25</PagesizeOption>
              <PagesizeOption value="50">50</PagesizeOption>
              <PagesizeOption value="100">100</PagesizeOption>
            </PagesizeOptions> */}
            <PaginationWrapper>
              {/* <TotalRowCount>
                Showing {recordsFrom} to {recordsTo} of {totalItemsCount}{" "}
                entries
              </TotalRowCount> */}
              <Pagination
                className="pagination-field"
                itemClass="page-item" // add it for bootstrap 4
                linkClass="page-link" // add it for bootstrap 4
                activePage={activePage}
                itemsCountPerPage={itemsCountPerPage}
                totalItemsCount={totalItemsCount}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={onPagination}
              />
            </PaginationWrapper>
          </>
        )}
        {isPaginationButton && (
          <>
            {dataOffset === 0 && rowData?.length !== itemsCountPerPage ? (
              <></>
            ) : (
              <>
                <PagesizeOptions
                  value={itemsCountPerPage}
                  onChange={onChangePageSize}
                >
                  <PagesizeOption value="10">10</PagesizeOption>
                  <PagesizeOption value="25">25</PagesizeOption>
                  <PagesizeOption value="50">50</PagesizeOption>
                  <PagesizeOption value="100">100</PagesizeOption>
                </PagesizeOptions>
                {/* <ButtonWrapper>
                  {dataOffset !== 0 && (
                    <Button onClick={onChangePage("back")}>Prev</Button>
                  )}
                  {rowData?.length === itemsCountPerPage && (
                    <Button onClick={onChangePage("next")}>Next</Button>
                  )}
                </ButtonWrapper> */}
              </>
            )}
          </>
        )}
      </TablePageOptionsWrapper>
    </Box>
  );
}

const TablePageOptionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: 24px;
`;

const PagesizeOptions = styled.select`
  position: relative;
  margin-right: 25px;
  border: 1px solid #ada8a8;
  padding: 4px;
  color: #6b6b6b;

  &:focus {
    outline: none;
  }
`;

const PagesizeOption = styled.option`
  border: 1px solid #ada8a8;

  &:checked {
    background: #6b6b6b -webkit-linear-gradient(bottom, #6b6b6b 0%, #6b6b6b 100%);
    color: #fff;
  }
`;

const PaginationWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  .pagination {
    margin: 0;
  }

  ul.pagination li a {
    text-decoration: none;
    color: #6b6b6b;
    font-size: 15px;

    &:hover {
      color: #6b6b6b;
    }
  }

  ul.pagination li.active a {
    color: white;
    background-color: #6b6b6b;
    border-color: #6b6b6b;

    &:hover {
      color: #fff;
    }

    &:focus {
      outline: none;
    }
  }
`;

// const TotalRowCount = styled.span`
//   color: #333;
//   margin-bottom: 5px;
// `;

// const Alert = styled.div`
//   font-size: 24px;
//   color: #333;
//   text-align: center;
// `;

// const ButtonWrapper = styled.div`
//   margin-top: 20px;
//   display: flex;
//   justify-content: flex-end;
//   position: relative;
// `;

// const Button = styled.button`
//   border: 1px solid #b7b7b7;
//   border-radius: 4px;
//   margin-left: 10px;
//   color: #404040;
//   cursor: pointer;
//   padding: 4px;
// `;
